const Airport = () => import('@/views/caats/Airport')
const InternationalRoute = () => import('@/views/caats/InternationalRoute');
const DomesticRoute = () => import('@/views/caats/DomesticRoute');
const DocumentStatistic = () => import('@/views/caats/DocumentStatistic');

const mainWidget = [{
        title: 'สำนักงานการบินพลเรือนแห่งประเทศไทย',
        path: '/admin/widget/:category/:widget_code(141)',
        component: Airport
    },
    {
        title: 'สำนักงานการบินพลเรือนแห่งประเทศไทย',
        path: '/admin/widget/:category/:widget_code(141.1)',
        component: InternationalRoute
    },
    {
        title: 'สำนักงานการบินพลเรือนแห่งประเทศไทย',
        path: '/admin/widget/:category/:widget_code(141.2)',
        component: DomesticRoute
    },
    {
        title: 'สำนักงานการบินพลเรือนแห่งประเทศไทย',
        path: '/admin/widget/:category/:widget_code(141.3)',
        component: DocumentStatistic
    },
]

export default mainWidget.map(data => {
    const { path, title, component, redirect, children } = data

    return {
        path: path,
        name: title,
        component: component,
        redirect: redirect,
        meta: {
            title: title,
            requiresAuth: true,
            breadcrumb: title
        },
        children: children
    }
})